module.exports = __webpack_public_path__ + "fe31fc4c9f3d9a9eb3934fefed83ee33.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/sir-hoots-a-lots-castle-empty.png
// module id = 2865
// module chunks = 0